module.exports = __webpack_public_path__ + "static/img/net-border-2.8ff3df03.png";